export default "__VITE_ASSET__CiBfPiVt__"